import styled from '@emotion/styled';
import { BREAKPOINTS, COLORS, COLORS_BASE, STYLES } from "../utils/consts"
import { CircleProps, SquareProps, HexagonProps } from '../types/dataTypes';
import { faAlignJustify } from '@fortawesome/free-solid-svg-icons';

export const TitleStyle = styled.h2(`
    font-size: 2.5rem;
    padding-bottom: 2rem;
    font-weight: bold;
`)

export const SubTitleStyle = styled.p<{fontWeight?: string, margin?: string}>(({fontWeight = 'normal', margin = '0'}) =>`
    font-size: 1.2rem;
    font-weight: ${fontWeight};
    margin: ${margin};
`)

export const CircleStyle = styled.div<CircleProps>(
  ({ color = '#000', size = 10, borderColor = 'white', borderSize = '2px' }) => `
    background-color: ${color};
    height: ${size}px;
    width: ${size}px;
    border-radius: 50%;
    border: ${borderSize} solid ${borderColor};
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.2);
    display: flex;
	  justify-content: center;
	  align-items: center;
`)

export const SquareStyle = styled.div<SquareProps>(
  ({ color = '#000', size = 10, borderColor = 'white', borderSize = '2px' }) => `
    background-color: ${color};
    height: ${size}px;
    width: ${size}px;
    border: ${borderSize} solid ${borderColor};
    // box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.2);
    display: flex;
	  justify-content: center;
	  align-items: center;
`)

export const HexagonStyle = styled.div<HexagonProps>(
  ({ color = '#000', size = 20, borderColor = 'white', borderSize = 2 }) => `
  z-index: 100;
  width: ${size}px;
    height: ${size}px;
    background: ${borderColor};
    position: relative;
    -webkit-clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
    clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
    ::before{
      content: '';
      height: calc(${size}px - ${borderSize}px);
      width: calc(${size}px - ${borderSize}px);
      background: ${color};
      display: block;
      position: absolute;
      top: ${borderSize/2}px;
      left: ${borderSize/2}px;
      -webkit-clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
      clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
    }
`)

export const LineStyle = styled.div<{ color?: string, thickness?: string, width?: string, dashed?: boolean }>(({ color = '#000', thickness = "3px", width = "20px", dashed = false }) => `
  ${dashed ? `background: repeating-linear-gradient(90deg,${color} 0 3px,#0000 0 5px);` : `background-color: ${color};`}
  width: ${width};
  height: ${thickness};
`)

export const HrStyle = styled.hr<{}>(() => `
  border-top: 2px dotted ${COLORS_BASE.GREYS.MAIN};
  border-bottom: none;
  border-left: none;
  border-right: none;
  margin: 10px 0;
`)

export const FontSmallStyle = styled.span<{ color?: string }>(
  ({ color = 'inherit' }) => `
  font-size: 0.9em;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: ${color};
`)

export const MapStyle = styled.div<{}>(() => `
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${STYLES.SIDEBAR_WIDTH}px;
  right: 0;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    left: 0;
  }
`)

export const ButtonStyle = styled.button<{ width?: string, height?: string, filledStyle?: boolean, buttonStyle?: string, padding?: string }>(
  ({ width = 'auto', height = '100%', disabled = false, filledStyle = false, buttonStyle = 'symbol', padding = '0px' }) => `
    display: flex;
    align-items: center;
    font-size: 14px;
    height: ${height};
    width:  ${width};
    padding: ${padding};
    background-color: ${filledStyle ? `${COLORS_BASE.SECONDARY.MAIN}` : '#ffffff00'};
    font-weight: ${(buttonStyle === 'secondary') ? 'bold' : 'normal'};
    border-style: none;
    padding: ${filledStyle ? '10px 15px' : '0px'};
    margin: ${filledStyle ? '5px' : '0px'};
    border-radius: 3px;
    color: ${filledStyle ? '#ffffff' : (buttonStyle === 'secondary') ? `${COLORS_BASE.SECONDARY.MAIN}` : 'inherit'}; /* Set text color to white when filledStyle is true */
    ${disabled ? 'cursor: not-allowed;' : ''}
    ${(buttonStyle === 'secondary') ? `
        text-decoration-line: underline;
        text-transform: uppercase;
    `: ''}
    ${!disabled ? `:hover{
        cursor: pointer;
    }`: ''}
`
);

export const LinkButtonStyle = styled.div<{ width?: string, height?: string, buttonStyle?: string, padding?: string }>(
  ({ height = 'auto',buttonStyle = 'symbol'}) => `
    display: flex;
    align-items: center;
    font-size: 16px;
    height: ${height};
    width:  fit-content;
    background-color: ${COLORS_BASE.SECONDARY.MAIN};
    font-weight: normal;
    border-style: none;
    padding: 10px 15px;
    margin: 30px 0px;
    border-radius: 3px;
    color: #ffffff;
    ${(buttonStyle === 'secondary') ? `
        text-decoration-line: underline;
        text-transform: uppercase;
    `: ''}
`
);

export const FieldsetStyle = styled.fieldset<{}>(() => `
  border: 0;
  margin: 0;
  padding: 0;  
`)

export const LegendStyle = styled.div<{ templateColumn?: string }>(({ templateColumn = '170px' }) => `
  position: relative;
  display: grid;
  grid-template-columns: 40px ${templateColumn};
  justify-content: center;
  align-items: center;
  p{
    padding: 5px 0;
  }
  > div{
    display: flex;
    justify-content: center;
  }
`)

export const OverlayContainerStyle = styled.div<{}>(() => `
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: ${COLORS_BASE.BRAND.DARKER};
    z-index: 7000;
    /* pointer-events: none; */
    background-color: ${`${COLORS_BASE.BRAND.MAIN}60`};
`)

export const ButtonContainerStyle = styled.div<{}>(() => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 0 10px 0;
    > * {
        margin: 10px;
    }
`)

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
`;

export const PopupContainerStyle = styled.div<{ padding?: string, margin?: string, left?: string, right?: string, top?: string, height?: string, textAlign?: string, zIndex?: string }>(
  ({ top = '0', left = '0', right = '0', height = 'inherit', textAlign = 'left', zIndex = '2000' }) => `
  position: relative;
  display: inline;
  top: ${top};
  left: ${left};
  right: ${right};
  height: ${height};
  text-align: ${textAlign};
  z-Index: ${zIndex};
  animation: slide-in 1s ease;
  @keyframes slide-in {
      0% { transform: translateY(100%); }
      100% { transform: translateY(0); }
  }    
`)

export  const SubHeaderStyle = styled.h2<{}>(() => `
  font-size: 16px;
`)

export const SubContainerStyle = styled.div<{}>(()=> `
  /* background-color: ${COLORS_BASE.SECONDARY.LIGHTEST}; */
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  margin: 5px 0;
`)

export const IconTextContainerStyle = styled.div<{justify_content?: string}>(({ justify_content = 'flex-start' }) => `
  display: flex;
  align-items: center;
  justify-content: ${justify_content};
  gap: 10px;
`)

export const SvgIcon = styled.img<{ width?: string, height?: string }>(({ width = '10px', height = '10px' }) => `
width: ${width};
height: ${height};
`)

export const LogoStyle = styled.img`
width: 3.8rem;
object-fit: contain;
padding: 1rem;
`

export const FilledLink = styled.div`
background-color: ${COLORS_BASE.SECONDARY.MAIN};
margin-top: 2rem;
color: white;
padding: 12px;
font-size: 14px;
border: none;
cursor: pointer;
border-radius: 4px;
`;

export const TextLinkStyle = styled.a<{}>(() => `
  color: ${COLORS_BASE.SECONDARY.MAIN};
  text-decoration: underline;
  cursor: pointer;
`)

export const ContainerContentStyle = styled.div<{ flexDirection?: string, alignItems?:string, textAlign?: string, width?: string, flexWrap?: string, marginTop?: string, justifyContent?: string }>(({ justifyContent='flex-start', flexDirection = 'row', textAlign = 'center', width = '60rem', flexWrap = 'nowrap', marginTop = '5rem', alignItems = 'stretch' }) => `
display: flex;
flex-direction: ${flexDirection};
flex-wrap: ${flexWrap};
align-items: ${alignItems};
align-content: ${alignItems};
justify-content: ${justifyContent};
padding: 2rem;
margin: ${marginTop};
width: ${width};
text-align: ${textAlign};
`)